const getTimestamp = (value) => {
  if (!value) return null;
  const timestamp = new Date(value).getTime();
  return Number.isFinite(timestamp) ? timestamp : null;
};

const getSequence = (item) => {
  const value = item?.deductionOrder;
  if (value === null || value === undefined || value === "") return null;
  const sequence = Number(value);
  return Number.isFinite(sequence) ? sequence : null;
};

export const getOrderedDeductionEntries = (item) => {
  const entries = [
    ...(Array.isArray(item?.impurities) ? item.impurities : []).map(
      (detail, index) => ({
        kind: "impurity",
        detail,
        fallbackIndex: index,
      })
    ),
    ...(Array.isArray(item?.deductedItems) ? item.deductedItems : []).map(
      (detail, index) => ({
        kind: "deductedItem",
        detail,
        fallbackIndex: (item?.impurities?.length || 0) + index,
      })
    ),
  ].filter(({ kind, detail }) => {
    const weight = Number(
      kind === "deductedItem" ? detail?.weight2 ?? detail?.weight : detail?.weight
    );
    return Number.isFinite(weight) && weight > 0;
  });

  const hasSequenceForAll = entries.every(
    ({ detail }) => getSequence(detail) !== null
  );
  const hasTimestampForAll = entries.every(
    ({ detail }) => getTimestamp(detail?.createdAt) !== null
  );

  return entries.sort((a, b) => {
    if (hasSequenceForAll) {
      return (
        getSequence(a.detail) - getSequence(b.detail) ||
        a.fallbackIndex - b.fallbackIndex
      );
    }

    if (hasTimestampForAll) {
      return (
        getTimestamp(a.detail.createdAt) - getTimestamp(b.detail.createdAt) ||
        a.fallbackIndex - b.fallbackIndex
      );
    }

    return a.fallbackIndex - b.fallbackIndex;
  });
};
